// extracted by mini-css-extract-plugin
export default {"estiamteGas":"NFCSFormPartFooter_estiamteGas__OOY92","notEnoughCta":"NFCSFormPartFooter_notEnoughCta__SOdXS"};